import React from 'react';
import {Route, IndexRoute} from 'react-router';
import Loadable from 'react-loadable';

import GuestLayout   from 'guests/GuestLayout'

// const AsyncSellerDashboard = Loadable({
//     loader: () => import(/* webpackChunkName: "subscription-management" */'sellers/SellerDashboardPage'),
//     loading: () => null
// });
 import SellerDashboard from 'sellers/SellerDashboardPage';
import UserDashboardPage from 'sellers/UserDashboardPage';

import SubscriptionManagement from 'sellers/subscriptions/SubscriptionManagement';

import UserFavoritesPage from 'sellers/favorites/UserFavoritesPage';
// const AsyncSellerProductsPage = Loadable({
//     loader: () => import(/* webpackChunkName: "schedule-pickup" */'sellers/products/SellerProductsPage.js'),
//     loading: () => null
// });

 import  SellerProductsPage from 'sellers/products/SellerProductsPage';
import  SellerSubscriptionsPage from 'sellers/subscriptions/SellerSubscriptionsPage';
import  SellerSettingsPage from 'sellers/SellerSettingsPage';
import  SellerReferralsPage from 'sellers/SellerReferralsPage';


import  SellerServicesPage from 'sellers/services/SellerServicesPage';
export default function () {
    return    (
        <Route path="client" component={GuestLayout}>
         <Route path="unsubscribe/:id" component={ SubscriptionManagement }/>
        <Route path="unsubscribe-notification/:token" component={  SubscriptionManagement  }/>

        <Route path="dashboard" component={ SellerDashboard}>
            <IndexRoute component={ SellerProductsPage }/>

            <Route path="products" component={ SellerProductsPage }/>
            <Route path="settings" component={ SellerSettingsPage }/>
            <Route path="services" component={ SellerServicesPage }/>
            <Route path="subscriptions" component={ SellerSubscriptionsPage }/>
            {/*<Route path="friends" component={ SellerReferralsPage }/>*/}
        </Route>
            <Route path="data" component={ UserDashboardPage}>
                 <Route path="favorites" component={ UserFavoritesPage }/>
            </Route>

    </Route>)
}
